enum MessageRoutesAPI {
  MESSAGE_LIST = '/customer-portal-service/Message',
  COUNT_MESSAGE = '/customer-portal-service/Message/Count',
  MESSAGE_ITEM = '/customer-portal-service/Message/:id',
  MESSAGE_FILE = '/customer-portal-service/Message/:id/File/:fileId',
}

enum MessageRoutesApplication {
  MESSAGE_LIST = '/application/message',
  MESSAGE_ITEM = '/application/message/:id',
}

export {
  MessageRoutesAPI,
  MessageRoutesApplication,
};
